<template>
    <base-page>
        <el-card style="margin: 5px 0px 5px 0px">
            <el-collapse accordion style="border: none">
                <el-collapse-item name="1" style="border: none">
                    <template slot="title">
                        <div slot="header" class="clearfix">
                            <titlu-pagina Titlu="Utilizatori" @on_add_clicked="show_dialog()" :AdaugaVisible="true" />
                        </div>
                    </template>
                    <div class="filtre">
                        <el-form @submit.prevent.native='refresh_info()'>
                            <el-row style="margin: 10px" class="input-group">

                                <el-col class="input-element">
                                    <el-form-item label='Nume'>
                                        <el-input v-model='Filters.Nume' />
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element">
                                    <el-form-item label='Email'>
                                        <el-input v-model='Filters.Email' />
                                    </el-form-item>
                                </el-col>

                                <el-col class="input-element">
                                    <el-form-item label="Tip utilizator">
                                        <el-select v-model="Filters.TipUtilizator" class="full-width" multiple collapse-tags-tooltip>
                                            <el-option label="Receptie" value="Receptie"></el-option>
                                            <el-option label="Mecanic" value="Mecanic"></el-option>
                                            <el-option label="Supervizor" value="Supervizor"></el-option>
                                            <el-option label="Management" value="Management"></el-option>
                                            <el-option label="Ajutor montator" value="AjutorMontator"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element">
                                    <el-form-item label="Status">
                                        <el-select v-model="Filters.Dezactivat" class="full-width">
                                            <el-option label="Toti" value="-1"></el-option>
                                            <el-option label="Dezactivati" value="1"></el-option>
                                            <el-option label="Activi" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element">
                                    <el-form-item label="Sters">
                                        <el-select v-model="Filters.Sters" class="full-width">
                                            <el-option label="Da" value="1"></el-option>
                                            <el-option label="Nu" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span='24'>
                                    <el-button type='primary' native-type='submit' @click='refresh_info()'> Aplica
                                    </el-button>
                                    <el-button type='danger' native-type='submit' @click='reset()'> Reseteaza
                                    </el-button>

                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </el-card>

        <el-table :data="Results">
            <el-table-column label="Nume">
                <template #default="scope">
                    {{ scope.row.Nume }}
                    <span v-if="scope.row.NumeAjutorMontator">
                        ({{ scope.row.NumeAjutorMontator }})
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop='TipUtilizator' label='Tip'></el-table-column>
            <el-table-column prop='Email' label='Email'></el-table-column>
            <!-- <el-table-column prop='LoginEsuat' label='LoginEsuat'></el-table-column> -->
            <el-table-column prop="Dezactivat" label="Dezactivat">
                <template slot-scope="scope">
                    {{ scope.row.Dezactivat == 0 ? "Nu" : "Da" }}
                </template>
            </el-table-column>
            <el-table-column label="Schimba tip">
                <template #default="scope">
                    <el-tooltip v-if="!['Mecanic', 'AjutorMontator'].includes(scope.row.TipUtilizator)" content="Nu se poate schimba">
                    <el-select
                        v-model="scope.row.TipUtilizator"
                        placeholder="Selectează tipul"
                        size="mini"
                        disabled
                        style="width: 150px;"
                    >
                        <el-option :label="scope.row.TipUtilizator" :value="scope.row.TipUtilizator"></el-option>
                    </el-select>
                    </el-tooltip>

                    <el-select
                    v-else
                    v-model="scope.row.TipUtilizator"
                    placeholder="Selectează tipul"
                    size="mini"
                    @change="schimba_tip(scope.row, $event)"
                    style="width: 150px;"
                    :disabled="scope.row.Dezactivat == 1"
                    >
                    <el-option label="Mecanic" value="Mecanic"></el-option>
                    <el-option label="Ajutor Montator" value="AjutorMontator"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="Restrictionare login IP">
                <template slot-scope="scope">
                    {{ scope.row.PermiteAccesIP == 0 ? "Nu" : "Da" }}
                    <span>
                        <el-tooltip :content="scope.row.Sters == '0' ? 'Modificare' : 'Indisponibil'">
                            <el-button plain icon="el-icon-edit" circle size="small"
                                @click="show_dialog_IP(scope.row.Id)" :disabled="scope.row.Sters === '1'" />
                        </el-tooltip>
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="right" fixed="right" label="Actiuni" width="140px">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.TipUtilizator == 'Mecanic'" content="Program lucru">
                        <el-button type="warning" icon="el-icon-coffee-cup" circle size="small"
                            @click="show_dialog_program(scope.row.Id)" :disabled="scope.row.Sters === '1'" />
                    </el-tooltip>

                    <el-tooltip :content="scope.row.Sters == '0' ? 'Modificare' : 'Indisponibil'">
                        <el-button type="primary" icon="el-icon-edit" circle size="small"
                            @click="show_dialog(scope.row.Id)" :disabled="scope.row.Sters === '1'" />
                    </el-tooltip>


                    <el-tooltip :content="scope.row.Sters == '0' ? 'Sterge' : 'Indisponibil'">
                        <el-button type="danger" icon="el-icon-delete" circle size="small"
                            @click="delete_item(scope.row)" :disabled="scope.row.Sters === '1'" />
                    </el-tooltip>

                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="refresh_info" @current-change="refresh_info"
            :page-size.sync="PaginationInfo.PerPage" :current-page.sync="PaginationInfo.Page"
            :total="PaginationInfo.RowCount" layout="pager" />
        <Utilizatori-dialog ref='dlg' @save="refresh_info()" />
        <Utilizatori-program ref='dlg_program' @save="refresh_info()" />
        <Utilizatori-dialog-ip ref='dlg_IP' @save="refresh_info()" />
    </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Utilizatori_dialog from '@/pages/Admin/utilizatori/Utilizatori_dialog.vue';
import Utilizatori_program from '@/pages/Admin/utilizatori/Utilizatori_program.vue';
import Utilizatori_dialog_IP from '@/pages/Admin/utilizatori/Utilizatori_dialog_IP.vue';
import TitluPagina from '@/widgets/TitluPagina';

export default {
    name: "utilizatori",
    extends: BasePage,
    components: {
        'base-page': BasePage,
        'Utilizatori-dialog': Utilizatori_dialog,
        'Utilizatori-dialog-ip': Utilizatori_dialog_IP,
        'Utilizatori-program': Utilizatori_program,
        'titlu-pagina': TitluPagina
    },
    data() {
        return {
            Results: [],
            base_url: '',
            Info: {
            },
            Filters: {
                Nume: '', Email: '', TipUtilizator: [], Dezactivat: '-1', Sters: '0',
            },
            OrderBy: {},
            PaginationInfo: { Page: 1, PerPage: 50, RowCount: 0, PageSizes: [10, 25, 50, 100, 200] },
        }
    },
    methods: {

        async get_info() {
            var response = await this.post("utilizatori/get_info");
            this.refresh_info();
        },

        async refresh_info() {
            // console.log(JSON.stringify(this.Filters));
            var response = await this.post("utilizatori/index", { Filters: this.Filters, OrderBy: this.OrderBy, PaginationInfo: this.PaginationInfo });
            this.Results = response.Results;
            this.PaginationInfo = response.PaginationInfo;
            //
            this.select_menu_item('utilizatori');
        },
        reset() {
            this.Filters = {
                Nume: '', Email: '', TipUtilizator: [], Dezactivat: '-1', Sters: '0',
            };
            this.refresh_info();
        },


        async delete_item(item) {
            var confirm = await this.$confirm(`Sunteti sigur ?`, 'Warning');
            if (confirm) {
                await this.post("utilizatori/delete_item", { id: item.Id });
                this.refresh_info();
            }
        },

        show_dialog(id) {
            this.$refs.dlg.show_me(id);
        },

        show_dialog_IP(id) {
            this.$refs.dlg_IP.show_me(id);
        },

        show_dialog_program(id) {
            this.$refs.dlg_program.show_me(id);
        },

        async schimba_tip(item, nou_tip) {
            try {
                const response = await this.post("utilizatori/schimba_tip", { id: item.Id, TipUtilizator: nou_tip });
                if(response && response.Message){
                    this.$message.success(response.Message);
                }
                this.refresh_info();
            } catch (error) {
                this.$message.error("Eroare la crearea utilizatorului cu tipul nou");
            }
        },
    },
    mounted() {
        if (!this.$has_right('Management') && !this.$has_right('Supervizor')) {
            this.$router.push('/no-rights')
            return
        }
        this.base_url = settings.BASE_URL;
        this.get_info();
    }
};
</script>

<style lang="less" scoped>
.top50 {
    margin-top: 20px;
}

.filtre {
    .el-input-number {
        width: 100% !important;
    }
}

.input-element {
    width: 23%;
    margin-right: 2%;
}

@media only screen and (max-width: 600px) {
    .input-element {
        width: 80%;
    }

    .el-tooltip__popper {
        width: 90%;
    }
}
</style>
